<script>
import TablePage from '@/found/components/table_page';
import Modal from '@/found/components/modal';
import configs from './table/config';
import DetailTable from './form/detailTable.vue';

export default {
  name: 'DistrictArea',
  extends: TablePage,
  data() {
    return {
      requestUrl: '/mdm/mdmRegionController/pageListAndTerminal',
      configs,
      formConfig: {},
      modalConfig: {
        title: '新增',
        visible: false,
        type: '',
      },
      params: {},
    };
  },
  components: {
    Modal,
    DetailTable,
  },

  methods: {
    cellClick({ row, column }) {
      if (column.property === 'noLicenseTerminalCount') {
        this.formName = 'DetailTable';
        this.propsObjInData.row = row;
        this.modalConfig.title = '终端信息';
        this.openFull();
      }
    },
    // 按钮点击事件
    modalClick({ val, row }) {
      if (val.code === 'head-import' || val.code === 'head-export') {
        return;
      }
      this.formConfig = {
        type: val.code,
        code: val.code,
        id: val.code !== 'head-add' ? row.regionCode : null,
      };
    },
    // 异步加载前置
    loadChildBefore({ row }) {
      return {
        parentCode: row.regionCode,
      };
    },
    // 搜索前置方法
    beforeGetList() {
      if (this.formData.regionCode || this.formData.regionName) {
        this.params = {};
      }
      return true;
    },
    setColumn(item) {
      const copyItem = item;
      if (copyItem.field === 'regionName') {
        copyItem.treeNode = true;
      }
      return copyItem;
    },
  },
  created() {
    // 重写获取配置信息
    this.getConfigList('districtArea_list');
  },
};
</script>
